module.exports = __webpack_public_path__ + "img/animals_frog.f327df20.png";